import { render, staticRenderFns } from "./TheGiftOptionsPanelProduct.vue?vue&type=template&id=1115ca99&scoped=true"
import script from "./TheGiftOptionsPanelProduct.vue?vue&type=script&lang=js"
export * from "./TheGiftOptionsPanelProduct.vue?vue&type=script&lang=js"
import style0 from "./TheGiftOptionsPanelProduct.vue?vue&type=style&index=0&id=1115ca99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115ca99",
  null
  
)

export default component.exports